import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, withKeys as _withKeys, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3327efe6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal",
  "data-testid-modal": ""
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { id: "modal-heading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_trap_focus = _resolveDirective("trap-focus")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "modal-box",
        onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('close')), ["esc"])),
        ref: "modal",
        tabindex: "0",
        role: "dialog",
        "aria-modal": "true",
        "data-testid-modal-box": "",
        "aria-labelledby": "modal-heading"
      }, [
        _createElementVNode("button", {
          class: "modal-box-close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          type: "button",
          "data-testid-modal-close": "",
          "aria-label": _ctx.$t('general.close')
        }, _hoisted_5, 8, _hoisted_3),
        _createElementVNode("section", {
          class: "modal-box-header",
          "data-testid-modal-header": "",
          "aria-label": _ctx.$t('general.modal-title')
        }, [
          _createElementVNode("h1", _hoisted_7, [
            _renderSlot(_ctx.$slots, "header", {}, undefined, true)
          ])
        ], 8, _hoisted_6),
        _renderSlot(_ctx.$slots, "content", {}, undefined, true)
      ], 32)), [
        [_directive_trap_focus, true]
      ])
    ])
  ]))
}